import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const growthTrackingListApi = async (data) => {
  const endPoint = `admin/grow-tracking/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
  
export const growthTrackingGraphApi = async (data) => {
  const endPoint = `admin/grow-tracking/graph?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};